/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import ChartAnnotations from 'chartjs-plugin-annotation';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Chart, registerables } from 'chart.js';
import { Provider } from 'react-redux';
// import mixpanel from 'mixpanel-browser';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './Helpers';
import './index.css';

// Only initialize Mixpanel if not in development environment
// if (
// 	// !(
// 	// window.location.origin.includes('dev3.resoee.com') ||
// 	// window.location.origin.includes('localhost') ||
// 	// window.location.origin.includes('192.168')
// 	// ) &&
// 	process.env.NODE_ENV === 'production'
// 	// eslint-disable-next-line no-constant-condition
// 	// true
// ) {
// 	mixpanel.init('962cbd109179d4a3169690a109d55da3', {
// 		debug: true,
// 		track_pageview: true,
// 		persistence: 'localStorage',
// 		autocapture: true,
// 	});
// }

Chart.register(...registerables, ChartAnnotations);
ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
